import { render } from "./TPayButton.vue?vue&type=template&id=0696486f&ts=true"
import script from "./TPayButton.vue?vue&type=script&lang=ts"
export * from "./TPayButton.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__